module.exports = __webpack_public_path__ + "img/hcml_gallery12.736b5df4.jpg";